



















import {Component, Prop, Vue} from 'vue-property-decorator'
import StatusTag from '@/components/lib/StatusTag.vue'
import TimezoneTooltip from "@/components/TimezoneTooltip.vue";
import {StatusTagType} from "./lib/models";
import {IHistory} from "@/entities/abstract";

@Component({
  components: {
    StatusTag,
    TimezoneTooltip
  }
})
export default class HistoryItem extends Vue {

  @Prop() readonly data!: IHistory
  @Prop() readonly scope!: string
  @Prop() readonly mapMethod!: (status?: string) => StatusTagType

  get message(): string {
    return this.$t(this.scope + '.logs.' + this.data.status) as string;
  }

  get label(): string {
    return this.$t(this.scope + '.' + this.data.status) as string;
  }

  get date(): string {
    return this.$storage.getters.getLocaleDate(this.data.date_creation || '');
  }

  get mappedStatus(): StatusTagType {
    return this.mapMethod(this.data.status);
  }

}
